import React from 'react';
import {TypeAheadSearchLayout} from '../../TypeaheadSearch/components/TypeAheadSearchLayout';
import {definedValue, nil} from "../../../../utils/input";
import {LocationSearchFieldProps} from "../props";

const LocationSearchField = ({
  search,
  onChangeSearchField,
  filterOptions,
  handleClear,
  handleSuggestionClick,
  searchNotFoundText,
  displaySuggestions,
  searchPlaceholder
}: LocationSearchFieldProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChangeSearchField) {
      const value = e.target.value;
      onChangeSearchField(value);
    }
  }
  const filteredOptions = definedValue(filterOptions, []);
  const displayOptions = filteredOptions.length > 0;
  return (
    <TypeAheadSearchLayout
      placeholder={searchPlaceholder}
      notFoundText={definedValue(searchNotFoundText, '')}
      enterKeyHint='search'
      filteredOptions={filteredOptions}
      role='search'
      onFocus={nil}
      onMouseEnter={nil}
      onBlur={nil}
      onMouseLeave={nil}
      onClickInput={nil}
      onKeyDown={nil}
      showSuggestions={displayOptions}
      handleOnChange={handleChange}
      handleClear={handleClear}
      handleKeyUp={nil}
      handleSuggestionClick={handleSuggestionClick}
      // we want to display not found text
      displaySuggestions={!!displaySuggestions}
      doSearch={nil}
      focus={false}
      searchedValue={search}
      displaySearchIcon={false}
      inputType='text'
    />
  );
};

export default React.memo(LocationSearchField);
